export const transactionDetailRoutes = [
  {
    path: 'transactionDetail/:transactionId',
    name: 'transaction_detail',
    component: () => import('@/views/dashboard/account/TransactionDetail.vue'),
    props: true,
  },
]
